import React, { Component } from "react";

import { Route, Routes as RouterRoutes } from "react-router";

import style from "./style.module.css";

import { DesignsPageWorkspaceSubHeader } from "./DesignsPageWorkspaceSubHeader/DesignsPageWorkspaceSubHeader";
import { DesignsPageTemplatesSubHeader } from "./DesignsPageTemplatesSubHeader/DesignsPageTemplatesSubHeader";

export class DesignsPageSubHeader extends Component {
  constructor(props) {
    super(props);

    this.WorkspaceSubHeaderComponent =
      this.WorkspaceSubHeaderComponent.bind(this);
    this.TemplatesSubHeaderComponent =
      this.TemplatesSubHeaderComponent.bind(this);
    this.subHeaderRef = React.createRef();
  }
  componentDidMount() {
    const {
      currentUser,
      currentTeam,
      fetchAllPersonalFolders,
      fetchAllTeamFolders
    } = this.props;

    if (currentUser && currentTeam) {
      fetchAllPersonalFolders({
        userId: currentUser.id,
        teamId: currentTeam.id
      });
      fetchAllTeamFolders({
        teamId: currentTeam.id
      });
      this.props.onFetchDesignsApproved();
      this.props.onFetchDesignsShared();
      // not fetching these at the moment since there is no place to display them
      // this.props.onFetchDesignsSharedApproved();
      this.props.onFetchDesignsSharedPendingApproval();
      // when a brand manager check for approved team designs
      if (this.props.userIsBrandManager) {
        this.props.onFetchTeamDesignsApproved();
      }
    }
  }

  WorkspaceSubHeaderComponent() {
    return (
      <DesignsPageWorkspaceSubHeader
        userHasDesignSharedWith={this.props.userHasDesignSharedWith}
        userHasApprovedDrafts={this.props.userHasApprovedDrafts}
        getPopoutTop={this.getPopoutTop}
        canSeeBrandManagerApprovedDesigns={
          this.props.canSeeBrandManagerApprovedDesigns
        }
      />
    );
  }

  TemplatesSubHeaderComponent() {
    const {
      isDesigner,
      isPurchasedTemplates: isAnyPurchasedTemplates,
      isArchivedTemplates: isAnyArchivedTemplates
    } = this.props;

    return (
      <DesignsPageTemplatesSubHeader
        getPopoutTop={this.getPopoutTop}
        isDesigner={isDesigner}
        isAnyPurchasedTemplates={isAnyPurchasedTemplates}
        isAnyArchivedTemplates={isAnyArchivedTemplates}
      />
    );
  }

  render() {
    return (
      <div className={style.subHeaderWrapper} ref={this.subHeaderRef}>
        <RouterRoutes>
          <Route
            path="catalogue/*"
            element={React.createElement(this.TemplatesSubHeaderComponent)}
          />
          <Route
            path="workspace/*"
            element={React.createElement(this.WorkspaceSubHeaderComponent)}
          />
          {/* Fallback for the designs index and the purchase-collection page,
              which also renders this subheader but is not under /designs/*.
              catalogue/workspace still win by route specificity. */}
          <Route
            path="*"
            element={React.createElement(this.WorkspaceSubHeaderComponent)}
          />
        </RouterRoutes>
      </div>
    );
  }
}

DesignsPageSubHeader.displayName = "DesignsPageSubHeader";

export default DesignsPageSubHeader;
